"use client";

import Link from "next/link";
import { ArrowLeft } from "lucide-react";
import { usePathname } from "next/navigation";

interface Category {
  title: string;
  slug: string;
}

const PAGE_TITLES: Record<string, string> = {
  "kak-otkrit-chop": "Как открыть ЧОП",
  "trebovaniya-kho": "Требования к КХО",
  "rating-chop-2026": "Рейтинг ЧОП 2026",
  "guides-b2b": "Гайды для заказчиков",
};

const PARENT_CATEGORIES: Record<string, string> = {
  "kak-otkrit-chop": "licenzirovanie-chop",
  "trebovaniya-kho": "specialnye-licenzii",
};

export function WikiBreadcrumbs({ categories }: { categories: Category[] }) {
  const pathname = usePathname();

  if (pathname === '/wiki') return null;

  const slug = pathname.split('/').pop() || '';
  const segments = pathname.split('/').filter(Boolean);

  const categoryTitles: Record<string, string> = {};
  categories.forEach(c => { categoryTitles[c.slug] = c.title; });

  const isCategoryPage = !!categoryTitles[slug];
  const parentSlug = !isCategoryPage ? PARENT_CATEGORIES[slug] : undefined;
  const parentTitle = parentSlug ? categoryTitles[parentSlug] : undefined;

  const pageTitle = isCategoryPage
    ? categoryTitles[slug]
    : PAGE_TITLES[slug] || null;

  const isGuidesB2bSubPage = segments.includes('guides-b2b') && !pathname.endsWith('/guides-b2b');

  const displayParentTitle = parentTitle || (isGuidesB2bSubPage ? PAGE_TITLES['guides-b2b'] : undefined);
  const displayParentSlug = parentSlug || (isGuidesB2bSubPage ? 'guides-b2b' : undefined);

  return (
    <div className="flex items-center gap-4 px-8 pt-6 pb-2">
      <Link
        href="/"
        className="flex items-center gap-3 hover:opacity-70 transition-opacity"
      >
        <ArrowLeft className="w-4 h-4 text-[hsl(var(--portal-text-muted))]" />
        <span className="text-lg font-bold tracking-widest uppercase hidden sm:inline-block">
          ОХРА.ПРО
        </span>
      </Link>
      <span className="text-[hsl(var(--portal-text-muted))] text-xs">/</span>
      <Link href="/wiki" className="text-xs text-[hsl(var(--portal-text-muted))] hover:text-[hsl(var(--portal-text))] transition-colors uppercase tracking-wider">
        База знаний
      </Link>
      {displayParentTitle && displayParentSlug && (
        <>
          <span className="text-[hsl(var(--portal-text-muted))] text-xs">/</span>
          <Link
            href={`/wiki/${displayParentSlug}`}
            className="text-xs text-[hsl(var(--portal-text-muted))] hover:text-[hsl(var(--portal-text))] transition-colors uppercase tracking-wider"
          >
            {displayParentTitle}
          </Link>
        </>
      )}
      {pageTitle && (
        <>
          <span className="text-[hsl(var(--portal-text-muted))] text-xs">/</span>
          <span className="text-xs text-[hsl(var(--portal-text))] uppercase tracking-wider truncate max-w-[200px] sm:max-w-[400px]">
            {pageTitle}
          </span>
        </>
      )}
    </div>
  );
}
